// Highcharts default color palette — kept in one place so the chart and the
// custom legend always agree on which color belongs to which series index.
export const HIGHCHARTS_COLORS = [
  '#7cb5ec',
  '#90ed7d',
  '#f7a35c',
  '#8085e9',
  '#f15c80',
  '#e4d354',
  '#2b908f',
  '#f45b5b',
  '#91e8e1',
];

export function getSeriesColorByIndex(index: number): string {
  return HIGHCHARTS_COLORS[index % HIGHCHARTS_COLORS.length];
}

const seriesColorIndexById = new Map<string, number>();
let nextSeriesColorIndex = 0;

export function getStableSeriesColorIndex(seriesId: string): number {
  const existingIndex = seriesColorIndexById.get(seriesId);

  if (existingIndex != null) {
    return existingIndex;
  }

  const assignedIndex = nextSeriesColorIndex;
  seriesColorIndexById.set(seriesId, assignedIndex);
  nextSeriesColorIndex += 1;

  return assignedIndex;
}

export function getStableSeriesColor(seriesId: string): string {
  return getSeriesColorByIndex(getStableSeriesColorIndex(seriesId));
}
